export default __webpack_public_path__ + "static/media/dubai-world-trade-center.a7094fa9.png";